module.exports = __webpack_public_path__ + "img/item-1(1920)new.08e8a1e9.jpg";